import {
  CategoryPicker,
  CategoryPickerProps,
} from '@work4all/components/lib/components/entity-picker/category-picker/CategoryPicker';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

type ProjectCategoryPickerProps = Omit<
  CategoryPickerProps,
  'filter' | 'entity'
>;

export function ProjectCategoryPicker(props: ProjectCategoryPickerProps) {
  return <CategoryPicker {...props} entity={Entities.projectCategoryClass} />;
}
